module.exports = __webpack_public_path__ + "static/media/PK-BackLogo.b721fdd2.png";